import { render, staticRenderFns } from "./dashboardInfoCard.vue?vue&type=template&id=0aab05c8&scoped=true&"
import script from "./dashboardInfoCard.vue?vue&type=script&lang=js&"
export * from "./dashboardInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./dashboardInfoCard.vue?vue&type=style&index=0&id=0aab05c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aab05c8",
  null
  
)

export default component.exports